type Props = {
    width?:number;
    height?:number;
    fill?:string;
}

const ColdIcon = ({
    width =20,
    height=20,
    fill="none"
}: Props) =>{
    return (
     <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_g_125_12063)">
<path d="M8.2614 16.523L7.22871 14.4576L4.95679 14.8707" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M8.2614 3.30444L7.22871 5.36983L4.95679 4.95675" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M11.5662 16.523L12.5989 14.4576L14.8708 14.8707" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M11.5662 3.30444L12.5989 5.36983L14.8708 4.95675" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14.0443 17.3491L11.5658 12.3922H8.26123" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M14.0446 2.47839L11.5662 7.43532L12.8054 9.91378" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M1.65234 9.91377H7.02235L8.26158 7.4353" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M16.5229 8.26147L15.2837 9.91378L16.5229 11.5661" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M18.1754 9.91382H12.8054L11.5662 12.3923" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M3.30444 8.26147L4.54367 9.91378L3.30444 11.5661" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.78296 17.3492L8.26142 12.3923L7.02219 9.91382" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.78296 2.47839L8.26142 7.43532H11.566" stroke="#E87722" strokeWidth="1.65231" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M8.35564 7.4353H11.3298V7.931L12.8169 9.41807V10.4095L11.8255 12.3922H8.35564L7.36426 9.41807L8.35564 7.4353Z" fill="#E87722"/>
</g>
<defs>
<filter id="filter0_g_125_12063" x="-0.198277" y="-0.198277" width="20.2242" height="20.2243" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feTurbulence type="fractalNoise" baseFrequency="10.086895942687988 10.086895942687988" numOctaves="3" seed="2726" />
<feDisplacementMap in="shape" scale="0.39655411243438721" xChannelSelector="R" yChannelSelector="G" result="displacedImage" width="100%" height="100%" />
<feMerge result="effect1_texture_125_12063">
<feMergeNode in="displacedImage"/>
</feMerge>
</filter>
</defs>
</svg>




    )
}

export default ColdIcon;